import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'phone'

export const dataPointDefinition = {
  retracedId: 'phone',
  name: 'Phone',
  description:
    'General facility phone number, e.g. phone number for general inquiries or to access the staff at reception desk.',
  meta: {},
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        pattern: '^\\+[1-9]\\d{1,14}$',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-bi-16',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 180,
  sectionId: '1.1',
  impactArea: 'About',
  impactAreaId: 'ABOUT',
}

export const validateSchema = data => {
  try {
    validate({
      value: data,
      schema: valueSchema,
      customErrorMessage:
        'There was an error saving your changes. Please update the companies phone number. It must be formatted to follow the E.164 standard, e.g. +4915732245678. It must start with + followed by the country code.',
    })
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({
      value: answer,
      schema: answerSchema,
      customErrorMessage:
        'There was an error saving your changes. Please update the companies phone number. It must be formatted to follow the E.164 standard, e.g. +4915732245678. It must start with + followed by the country code.',
    })
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
